import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadInstaDelivery: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source={"INSTADELIVERY"} title={"Importar catálogo InstaDelivery"}
  instructions={"Copie a URL do cardápio digital da sua loja no InstaDelivery."}
  placeholder={"https://instadelivery.com.br/sua-loja"} />;

export default UploadInstaDelivery;
